<div class="hidden sm:block background__background-upper"></div>
<div class="hidden sm:block background__background-lower"></div>
<div class="sm:hidden background__mobile-background flex-1"></div>
